// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"pQ-z","categoryName":"qQ-z","categoryNameSearchHeader":"rQ-z","categoryContent":"sQ-z","bottomAligned":"tQ-z","image":"uQ-z","imageNoBackground":"vQ-z"};